import { useMemo } from "react";
import type { TicketConversationExportDto } from "../../shared/ticket-export";
import { exportText, exportTimezone, formatExportDate, prepareExportMessage } from "../lib/ticketExport";
import { ticketLabel } from "../lib/format";

export function TicketConversationExport({ ticket, timeZone }: { ticket: TicketConversationExportDto; timeZone: string }) {
  const zone = exportTimezone(timeZone);
  const messages = useMemo(() => ticket.messages.map(message => ({ ...message, printHtml: prepareExportMessage(message) })), [ticket]);
  return <main className="ticket-export-document">
    <header className="ticket-export-heading">
      <p className="ticket-export-brand">Next-Cart Support</p>
      <h1>Ticket conversation</h1>
      <p className="ticket-export-subject"><strong>{ticketLabel(ticket.number)}</strong> {exportText(ticket.subject)}</p>
      <dl className="ticket-export-meta">
        <div><dt>Created</dt><dd>{formatExportDate(ticket.createdAt, zone)}</dd></div>
        <div><dt>Status at export</dt><dd>{ticket.status.replace(/_/g, " ")}</dd></div>
        <div><dt>Exported</dt><dd>{formatExportDate(ticket.exportedAt, zone)}</dd></div>
        <div><dt>Time zone</dt><dd>{zone}</dd></div>
      </dl>
      <p className="ticket-export-scope">{messages.length} public {messages.length === 1 ? "message" : "messages"}, oldest first. Email addresses are redacted. Quoted history, attachments, inline images and internal notes are omitted.</p>
    </header>
    {messages.length ? messages.map((message, index) => <article className="ticket-export-message" key={message.id}>
      <header className="ticket-export-message__header">
        <div><span className="ticket-export-message__index">{index + 1}.</span> <strong>{exportText(message.authorName)}</strong> <span className="ticket-export-message__role">{message.authorType === "customer" ? "Customer" : message.authorType === "staff" ? "Support" : "System"}</span></div>
        <time dateTime={message.createdAt}>{formatExportDate(message.createdAt, zone)}</time>
      </header>
      <div className="ticket-export-message__body" dangerouslySetInnerHTML={{ __html: message.printHtml }} />
      {message.authorType === "staff" && message.deliveryStatus && <p className="ticket-export-delivery">Email status: {message.deliveryStatus}</p>}
    </article>) : <p>No public messages in this ticket.</p>}
    <footer className="ticket-export-footer">End of conversation · {ticketLabel(ticket.number)} · Redacted export. The original ticket is unchanged.</footer>
  </main>;
}
